// extracted by mini-css-extract-plugin
module.exports = {"open":"styles_open__P3xNA","close":"styles_close__53D4R","arrow":"styles_arrow__t2c8o","small":"styles_small__Gar_T","medium":"styles_medium__55SCE"};